import Fuse from 'fuse.js';

/**
 * Fuse's extended search treats each word of the query as its own fuzzy match and requires all of
 * them, so "spag bol" finds Spaghetti Bolognese and "chk curry" finds Chicken Curry, which a single
 * fuzzy pattern over the whole query does not. It also gives these characters meaning (exact match,
 * negation, prefix, suffix, or), and a meal name typed with an apostrophe must not turn into an
 * operator, so they are read as spaces.
 */
const OPERATORS = /[!^'=$|]/g;

const FUSE_OPTIONS = {
	keys: ['name'],
	threshold: 0.4,
	ignoreLocation: true,
	useExtendedSearch: true,
};

const byName = (a, b) => String(a.name).localeCompare(String(b.name));

export const normalizeIdeaName = (name) => String(name || '').trim().replace(/\s+/g, ' ').toLowerCase();

/** The ideas matching `query`, best first; every idea by name when the query is blank. */
export default function searchMealIdeas(ideas, query) {
	const cleaned = String(query || '').replace(OPERATORS, ' ').trim();
	if(!cleaned) {
		return [...ideas].sort(byName);
	}
	return new Fuse(ideas, FUSE_OPTIONS).search(cleaned).map((result) => result.item);
}

/** The idea already called `name`, ignoring case and spacing, so the picker offers no duplicate. */
export function findIdeaNamed(ideas, name) {
	const wanted = normalizeIdeaName(name);
	return wanted ? ideas.find((idea) => normalizeIdeaName(idea.name) === wanted) || null : null;
}
